import React from 'react';
import { get as _get } from 'lodash';
import { Company, Technographics } from '../../types';
import Icon from '../common/Icon';

interface CompanyCardProps {
  company: Company;
  address?: string;
  location: string;
  technographics?: Technographics | null;
}

/** Returns the first letter of the first two words in the name, uppercased. */
/*const getInitials = (companyName: string | null | undefined): string => {
  if (!companyName) return '?';
  return companyName
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('') || '?';
};*/

const CompanyCard: React.FC<CompanyCardProps> = ({ company, address, location, technographics }) => {
  const name = _get(company, 'name') || 'Unknown Company';
  const website = _get(company, 'website') || '';
  const industry = _get(company, 'industry') || 'N/A';
  const size = _get(company, 'size') || 'N/A';
  //const initials = getInitials(name);
  const displayAddress = address || location || '';
  //const skills: string[] = _get(technographics, 'skills') || [];
  //const connections: number = _get(technographics, 'connections') || 0;
  //const followers: number = _get(technographics, 'followers') || 0;
  //const rawCategories: Record<string, string[]> = _get(technographics, 'categories') || {};
  // Only keep categories that have at least one value
  //const categories = Object.entries(rawCategories).filter(([, values]) => values.length > 0);

  return (
    <div className="bg-white border border-brand-grey01 rounded-brand p-8 shadow-sm">
      <h3 className="text-xl font-bold mb-6 flex items-center gap-2 text-brand-black">
        <Icon name="domain" className="text-brand-aqua" />
        Company
      </h3>
      
      <div className="flex items-center gap-4 mb-8">
        <div>
          <p className="font-extrabold text-lg">{name}</p>
          {website && (
            <a
              href={website.startsWith('http') ? website : `https://${website}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-brand-pink text-xs hover:underline"
            >
              {website}
            </a>
          )}
        </div>
      </div>

      <div className="space-y-4 text-sm">
        <div className="flex justify-between border-b border-brand-grey01 pb-2">
          <span className="text-brand-grey08">Industry</span>
          <span className="font-bold ml-3">{industry}</span>
        </div>
        <div className="flex justify-between border-b border-brand-grey01 pb-2">
          <span className="text-brand-grey08">Size</span>
          <span className="font-bold ml-3">{size}</span>
        </div>
        <div className="flex justify-between border-b border-brand-grey01 pb-2">
          <span className="text-brand-grey08">Address</span>
          <span className="font-bold ml-3">{displayAddress}</span>
        </div>
        {/*((technographics || null) !== null) && (
          <>
            <div className="flex justify-between border-b border-brand-grey01 pb-2">
              <span className="text-brand-grey08">Connections</span>
              <span className="font-bold">{connections}</span>
            </div>
            <div className="flex justify-between border-b border-brand-grey01 pb-2">
              <span className="text-brand-grey08">Followers</span>
              <span className="font-bold">{followers}</span>
            </div>
            categories.length > 0 && (
              <div className="space-y-3 pt-1">
                {categories.map(([key, values]) => (
                  <div key={key} className="flex gap-3">
                    <span className="text-brand-grey08 shrink-0 w-28">{key}</span>
                    <span className="font-bold text-brand-black leading-relaxed text-right flex-1">
                      {values.join(', ')}
                    </span>
                  </div>
                ))}
              </div>
            )}
            {skills.length > 0 && (
              <div className="border-b border-brand-grey01 pb-3">
                <span className="text-brand-grey08 block mb-1">Skills</span>
                <span className="font-bold text-brand-black leading-relaxed">{skills.join(', ')}</span>
              </div>
            )
          </>
        )*/}
      </div>
    </div>
  );
};

export default CompanyCard;
